import { getCurrentUserData } from "Application/User/UserService";
import { Box, Paper } from "@mui/material";
export default function Dashboard() {
  const currentUser = getCurrentUserData();
  if (!currentUser.isUserInternal()){
    return <ExternalDashboard />
  }

  return (
    <div>
      <h2>{"Vous etes connecté en tant que " + currentUser.getUserType()}</h2>
    </div>
  );
}

function ExternalDashboard(){
  return <Box sx={{
      display: "flex", 
      justifyContent: 'center',
      alignItems: "center",
      height: '100%'
      }}>

      <Paper
        elevation={1}
        sx={{
          display: "flex", 
          alignItems: 'center', 
          flexDirection: "column", 
          textAlign: "center", 
          gap: 2 ,
          padding: 3,
          borderRadius: 5,
        }}
        >
          <h5>
            VERSION 1.0
          </h5>
          <p>
            Votre compte est désormais actif.
          </p>
          <p>
            Cette page affichera vos statistiques d’utilisation au fur et à mesure de votre activité.
          </p>    
      </Paper>
    </Box>
}